// import React, { useEffect, useState, useCallback } from "react";
// import "../assets/AttendanceSummary.css";
// import axios from "axios";
// import { toast } from "react-toastify";

// const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50, 100];
// const API_URL = "https://payyug.in/api";

// const AttendanceSummary = () => {
//   const [attendances, setAttendances] = useState([]);
//   const [branchs, setBranchs] = useState([]);
//   const [employees, setEmployees] = useState([]);

//   const [selectedBranch, setSelectedBranch] = useState(null);
//   const [selectedEmployee, setSelectedEmployee] = useState(null);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalRecords, setTotalRecords] = useState(0);

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const superAdminId = localStorage.getItem("adminuserId");
//  const calculateSalary = async (employeeId, month, year) => {
//   console.log("payloads are", employeeId, month, year);
//   try {
//     const response = await axios.post(
//       "https://payyug.in/api/calculate-salary/employe",
//       {
//         employeeId,
//         month,
//         year,
//         superAdminId,
//       }
//     );

//     toast.success("Salary calculated successfully!");
//     return response.data;
//   } catch (error) {
//     const msg =
//       error?.response?.data?.message || "Something went wrong while calculating salary";

//     toast.error(msg); 
//     console.error("Error calculating salary:", msg);
//     return null; // prevent crash
//   }
// };


//   /* ================= FETCH BRANCH ================= */
//   useEffect(() => {
//     const fetchBranch = async () => {
//       try {
//         const res = await axios.get(`${API_URL}/get-branch`, {
//           params: {
//             SuperAdminId: localStorage.getItem("adminuserId"),
//             limit: "all",
//           },
//         });
//         setBranchs(res?.data?.branches || []);
//       } catch (err) {
//         console.error(err);
//       }
//     };
//     fetchBranch();
//   }, []);

//   /* ================= FETCH EMPLOYEES ================= */
//   useEffect(() => {
//     if (!selectedBranch) {
//       setEmployees([]);
//       return;
//     }

//     const fetchEmployees = async () => {
//       try {
//         const res = await axios.get(`${API_URL}/get-employ`, {
//           params: {
//             superAdminId: localStorage.getItem("adminuserId"),
//             branchId: selectedBranch.id,
//             limit: 50,
//           },
//         });
//         setEmployees(res?.data?.data || []);
//       } catch (err) {
//         console.error(err);
//       }
//     };

//     fetchEmployees();
//   }, [selectedBranch]);

//   /* ================= FETCH ATTENDANCE ================= */
//   const fetchAttendance = useCallback(async () => {
//     try {
//       setLoading(true);
//       setError("");

//       const token = localStorage.getItem("authToken");
//       const superAdminId = localStorage.getItem("adminuserId");

//       const res = await axios.get(`${API_URL}/attendance-finalize/report-all`, {
//         params: {
//           superAdminId,
//           currentPage,
//           pageSize: rowsPerPage,
//           branchId: selectedBranch?.id,
//           employeeId: selectedEmployee?.id,
//         },
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       setAttendances(res?.data?.data || []);
//       setTotalPages(res?.data?.totalPages || 1);
//       setTotalRecords(res?.data?.totalRecords || 0);
//     } catch (err) {
//       setError(err?.response?.data?.message || "Failed to fetch attendances");
//     } finally {
//       setLoading(false);
//     }
//   }, [currentPage, rowsPerPage, selectedBranch, selectedEmployee]);

//   /* ================= DEFAULT LOAD ================= */
//   useEffect(() => {
//     fetchAttendance();
//   }, [fetchAttendance]);

//   /* ================= FILTER SUBMIT ================= */
//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!selectedBranch || !selectedEmployee) {
//       toast.error("Please select branch and employee");
//       return;
//     }

//     setCurrentPage(1);
//     fetchAttendance();
//   };

//   /* ================= PER PAGE ================= */
//   const handleItemsPerPageChange = (e) => {
//     setRowsPerPage(Number(e.target.value));
//     setCurrentPage(1);
//   };

//   return (
//     <div className="attendance-summary-container">
//       <h1 className="attendance-summary-heading">Attendance Summary</h1>

//       {/* ================= FILTER ================= */}
//       <section className="attendance-summary-top">
//         <form className="attendance-summary-form" onSubmit={handleSubmit}>
//           <div className="attendance-summary-form-section">
//             <div className="attendance-summary-form-input-fields">
//               <label>Select Branch</label>
//               <select
//                 value={selectedBranch?.id || ""}
//                 onChange={(e) =>
//                   setSelectedBranch(
//                     branchs.find((b) => b.id === Number(e.target.value)),
//                   )
//                 }
//               >
//                 <option value="">Select Branch</option>
//                 {branchs.map((b) => (
//                   <option key={b.id} value={b.id}>
//                     {b.name}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="attendance-summary-form-input-fields">
//               <label>Select Employee</label>
//               <select
//                 disabled={!selectedBranch}
//                 value={selectedEmployee?.id || ""}
//                 onChange={(e) =>
//                   setSelectedEmployee(
//                     employees.find((emp) => emp.id === Number(e.target.value)),
//                   )
//                 }
//               >
//                 <option value="">Select Employee</option>
//                 {employees.map((emp) => (
//                   <option key={emp.id} value={emp.id}>
//                     {emp.fullName} - {emp.id}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           <div className="attendance-summary-form-submit-btn">
//             <button type="submit">
//               {loading ? "Loading..." : "Get Records"}
//             </button>
//           </div>
//         </form>
//       </section>

//       {/* ================= REPORT ================= */}
//       <div className="attendance-summary-report-container">
//         <h1>Attendance Entries Report</h1>

//         <div className="attendance-summary-report-filter-div">
//           <div className="attendance-summary-filter">
//             <label>Show </label>
//             <select value={rowsPerPage} onChange={handleItemsPerPageChange}>
//               {ITEMS_PER_PAGE_OPTIONS.map((num) => (
//                 <option key={num} value={num}>
//                   {num}
//                 </option>
//               ))}
//             </select>
//             <span> entries</span>
//           </div>

//           <div className="attendance-summary-total-records">
//             Total Records: {totalRecords}
//           </div>
//         </div>

//         <div className="attendance-summary-report-table-container">
//           {error && <p className="error-text">{error}</p>}

//           <table className="attendance-summary-report-table">
//             <thead>
//               <tr>
//                 <th>SN</th>
//                 <th>Employee Name</th>
//                 <th>Employee Id</th>
//                 <th>Paid Days</th>
//                 <th>Unpaid Days</th>
//                 <th>Total Days</th>
//                 <th>Month</th>
//                 <th>Year</th>
//                 <th>Action</th>
//               </tr>
//             </thead>

//             <tbody>
//               {attendances.length > 0 ? (
//                 attendances.map((item, index) => (
//                   <tr key={item.id}>
//                     <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
//                     <td>{item.employee.fullName||"N/A"}</td>
//                     <td>{item.employee.userId||"N/A"}</td>
//                     <td>{item.paidDays||"N/A"}</td>
//                     <td>{item.unpaidDays||"N/A"}</td>
//                     <td>{item.totalDays||"N/A"}</td>
//                     <td>
//                       {new Date(0, item.month - 1).toLocaleString("en-US", {
//                         month: "long",
//                       })} - {item.month}
//                     </td>

//                     <td>{item.year}</td>
//                     <td>
//                       <div className="attendance-calculate-salary-btn">
//                         <button
//                           onClick={() =>
//                             calculateSalary(item.employee.id, item.month, item.year)
//                           }
//                         >
//                           Calculate Salary
//                         </button>

//                       </div>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="8" style={{ textAlign: "center" }}>
//                     {loading ? "Loading..." : "No records found"}
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* ================= PAGINATION ================= */}
//       {/* {totalPages > 1 && ( */}
//       <div className="attendance-summary-pagination-div">
//         <button
//           disabled={currentPage === 1}
//           onClick={() => setCurrentPage((p) => p - 1)}
//         >
//           ⬅ Prev
//         </button>

//         <span>
//           Page {currentPage} of {totalPages}
//         </span>

//         <button
//           disabled={currentPage === totalPages}
//           onClick={() => setCurrentPage((p) => p + 1)}
//         >
//           Next ➡
//         </button>
//       </div>
//       {/* )} */}
//     </div>
//   );
// };

// export default AttendanceSummary;






import React, { useEffect, useState, useCallback } from "react";
import "../assets/AttendanceSummary.css";
import axios from "axios";
import { toast } from "react-toastify";


import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";


const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50, 100];
const API_URL = "https://payyug.in/api";

const AttendanceSummary = () => {
  const [attendances, setAttendances] = useState([]);
  const [branchs, setBranchs] = useState([]);
  const [employees, setEmployees] = useState([]);

  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const superAdminId = localStorage.getItem("adminuserId");






//  const calculateSalary = async (employeeId, month, year) => {
//   console.log("payloads are", employeeId, month, year);
//   try {
//     const response = await axios.post(
//       "https://payyug.in/api/calculate/employe-salery-new",
//       {
//         employeeId,
//         month,
//         year,
//         superAdminId,
//       }
//     );

//     toast.success("Salary calculated successfully!");
//     return response.data;
//   } catch (error) {
//     const msg =
//       error?.response?.data?.message || "Something went wrong while calculating salary";

//     toast.error(msg); 
//     console.error("Error calculating salary:", msg);
//     return null; // prevent crash
//   }
// };

const calculateSalary = async (employeeId, month, year) => {
  console.log("payloads are", employeeId, month, year);
  try {
    const response = await axios.post(
      "https://payyug.in/api/calculate/employe-salery-new",
      {
        employeeId,
        month,
        year,
        superAdminId,
      }
    );

    // 1. Check the success flag inside the 200 OK response
    if (response.data.success) {
      toast.success(response.data.message || "Salary calculated successfully!");
      return response.data;
    } else {
      // 2. This handles the "Attendance already finalized" or other logic errors
      toast.error(response.data.message || "Calculation failed.");
      return null;
    }

  } catch (error) {
    // 3. This handles actual server errors (400, 409, 500)
    const msg =
      error?.response?.data?.message || "Something went wrong while calculating salary";

    toast.error(msg); 
    console.error("Error calculating salary:", msg);
    return null;
  }
};


const downloadExcel = () => {
  if (!attendances || attendances.length === 0) {
    toast.error("No attendance data to export");
    return;
  }

  const excelData = attendances.map((item, index) => ({
    "SN": (currentPage - 1) * rowsPerPage + index + 1,
    "Employee Name": item.employee?.fullName,
    "Employee ID": item.employee?.userId,
    "Paid Days": item.paidDays,
    "Unpaid Days": item.unpaidDays,
    "Total Days": item.totalDays,
    "Month": new Date(0, item.month - 1).toLocaleString("en-US", {
      month: "long",
    }),
    "Year": item.year,
  }));

  const worksheet = XLSX.utils.json_to_sheet(excelData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance Summary");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const file = new Blob([excelBuffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(file, `Attendance_Summary_${Date.now()}.xlsx`);
};


const downloadPDF = () => {
  if (!attendances || attendances.length === 0) {
    toast.error("No attendance data to export");
    return;
  }

  const doc = new jsPDF("l", "mm", "a4");

  doc.text("Attendance Summary Report", 14, 15);

  const tableHead = [[
    "SN",
    "Employee Name",
    "Employee ID",
    "Paid Days",
    "Unpaid Days",
    "Total Days",
    "Month",
    "Year",
  ]];

  const tableBody = attendances.map((item, index) => [
    (currentPage - 1) * rowsPerPage + index + 1,
    item.employee?.fullName,
    item.employee?.userId,
    item.paidDays,
    item.unpaidDays,
    item.totalDays,
    `${new Date(0, item.month - 1).toLocaleString("en-US", { month: "long" })} (${item.month})`,
    item.year,
  ]);

  autoTable(doc, {
    head: tableHead,
    body: tableBody,
    startY: 20,
    styles: { fontSize: 9 },
    theme: "grid",
  });

  doc.save(`Attendance_Summary_${Date.now()}.pdf`);
};



  /* ================= FETCH BRANCH ================= */
  useEffect(() => {
    const fetchBranch = async () => {
      try {
        const res = await axios.get(`${API_URL}/get-branch`, {
          params: {
            SuperAdminId: localStorage.getItem("adminuserId"),
            limit: "all",
          },
        });
        setBranchs(res?.data?.branches || []);
      } catch (err) {
        console.error(err);
      }
    };
    fetchBranch();
  }, []);

  /* ================= FETCH EMPLOYEES ================= */
  useEffect(() => {
    if (!selectedBranch) {
      setEmployees([]);
      return;
    }

    const fetchEmployees = async () => {
      try {
        const res = await axios.get(`${API_URL}/get-employ`, {
          params: {
            superAdminId: localStorage.getItem("adminuserId"),
            branchId: selectedBranch.id,
            limit: 50,
          },
        });
        setEmployees(res?.data?.data || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchEmployees();
  }, [selectedBranch]);

  /* ================= FETCH ATTENDANCE ================= */
  const fetchAttendance = useCallback(async () => {
    try {
      setLoading(true);
      setError("");

      const token = localStorage.getItem("authToken");
      const superAdminId = localStorage.getItem("adminuserId");

      const res = await axios.get(`${API_URL}/attendance-finalize/report-all`, {
        params: {
          superAdminId,
          currentPage,
          pageSize: rowsPerPage,
          branchId: selectedBranch?.id,
          employeeId: selectedEmployee?.id,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setAttendances(Array.isArray(res?.data?.data) ? res.data.data : [] );
      setTotalPages(res?.data?.totalPages || 1);
      setTotalRecords(res?.data?.totalRecords || 0);
    } catch (err) {
      setError(err?.response?.data?.message || "Failed to fetch attendances");
    } finally {
      setLoading(false);
    }
  }, [currentPage, rowsPerPage, selectedBranch, selectedEmployee]);

  /* ================= DEFAULT LOAD ================= */
  useEffect(() => {
    fetchAttendance();
  }, [fetchAttendance]);

  /* ================= FILTER SUBMIT ================= */
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!selectedBranch || !selectedEmployee) {
      toast.error("Please select branch and employee");
      return;
    }

    setCurrentPage(1);
    fetchAttendance();
  };

  /* ================= PER PAGE ================= */
  const handleItemsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  return (
    <div className="attendance-summary-container">
      <h1 className="attendance-summary-heading">Attendance Summary</h1>

      {/* ================= FILTER ================= */}
      <section className="attendance-summary-top">
        <form className="attendance-summary-form" onSubmit={handleSubmit}>
          <div className="attendance-summary-form-section">
            <div className="attendance-summary-form-input-fields">
              <label>Select Branch</label>
              <select
                value={selectedBranch?.id || ""}
                onChange={(e) =>
                  setSelectedBranch(
                    branchs.find((b) => b.id === Number(e.target.value)),
                  )
                }
              >
                <option value="">Select Branch</option>
                {branchs.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="attendance-summary-form-input-fields">
              <label>Select Employee</label>
              <select
                disabled={!selectedBranch}
                value={selectedEmployee?.id || ""}
                onChange={(e) =>
                  setSelectedEmployee(
                    employees.find((emp) => emp.id === Number(e.target.value)),
                  )
                }
              >
                <option value="">Select Employee</option>
                {employees.map((emp) => (
                  <option key={emp.id} value={emp.id}>
                    {emp.fullName} - {emp.id}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="attendance-summary-form-submit-btn">
            <button type="submit">
              {loading ? "Loading..." : "Get Records"}
            </button>
          </div>
        </form>
      </section>

      {/* ================= REPORT ================= */}
      <div className="attendance-summary-report-container">
        <h1>Attendance Entries Report</h1>

        <div className="attendance-summary-report-filter-div">
          <div className="attendance-summary-filter">
            <label>Show </label>
            <select value={rowsPerPage} onChange={handleItemsPerPageChange}>
              {ITEMS_PER_PAGE_OPTIONS.map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </select>
            <span> entries</span>
          </div>

          <div className="attendance-summary-total-records">
            Total Records: {totalRecords}
          </div>
        </div>

        <div className="attendance-summary-report-table-container">
          {error && <p className="error-text">{error}</p>}


          <div style={{ display: "flex", gap: "12px", marginBottom: "15px" }}>
  <button onClick={downloadExcel} className="attendance-summary-download-btn">
    ⬇️  Excel
  </button>

  <button onClick={downloadPDF} className="attendance-summary-download-btn">
    ⬇️  PDF
  </button>
</div>


          <table className="attendance-summary-report-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Employee Name</th>
                <th>Employee Id</th>
                <th>Present Days</th>
                <th>Absent Days</th>
                <th>late Days</th>
                <th>Month</th>
                <th>Year</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {attendances.length > 0 ? (
                attendances.map((item, index) => (
                  <tr key={item.id}>
                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>

                    <td>{item.employee?.fullName || "N/A"}</td>

                    <td>{item.employee?.userId || "N/A"}</td>

                    <td>{item.presentDays}</td>
                    <td>{item.absentDays}</td>
                    <td>{item.lateDays}</td>

                    <td>
                      {new Date(0, item.month - 1).toLocaleString("en-US", {
                        month: "long",
                      })}{" "}
                      - {item.month}
                    </td>

                    <td>{item.year}</td>

                    <td>
                      <div className="attendance-calculate-salary-btn">
                        <button
                          disabled={!item.employee?.id}
                          onClick={() =>
                            item.employee?.id &&
                            calculateSalary(
                              item.employee.id,
                              item.month,
                              item.year
                            )
                          }
                        >
                          Calculate Salary
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" style={{ textAlign: "center" }}>
                    {loading ? "Loading..." : "No records found"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* ================= PAGINATION ================= */}
      {/* {totalPages > 1 && ( */}
      <div className="attendance-summary-pagination-div">
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((p) => p - 1)}
        >
          ⬅ Prev
        </button>

        <span>
          Page {currentPage} of {totalPages}
        </span>

        <button
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage((p) => p + 1)}
        >
          Next ➡
        </button>
      </div>
      {/* )} */}
    </div>
  );
};

export default AttendanceSummary;